module.exports = __webpack_public_path__ + "img/digital_1.d58ee0a7.jpg";